import React from "react";
import { Link } from "react-router-dom";
import propTypes from "prop-types";
import './tile.css';

const Tile = props => {
    const {
        title,
        icon,
        text,
        ctaPath,
        ctaLabel,
        tileColor,
        className,
    } = props;

    return (
        <div className={`serviceBox shadow-md bg-slate-200 dark:bg-night-sky-blue-600 dark:text-slate-200 ${className}`}>
            <div className={`icon`} style={{ backgroundColor: tileColor }}>
                <div className="icon-wrapper">
                    {icon}
                </div>
            </div>
            <div className="content">
                <h2>{title}</h2>
                <p>{text}</p>
                {ctaPath &&
                    <Link to={ctaPath} className="font-medium text-aida-red flex justify-center mt-2">
                        {ctaLabel} 
                        <svg className="w-6 h-6 ml-2 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </Link>
                }
            </div>
        </div>
    );
}

Tile.defaultProps = {
    bgColor: '#e2e8f0',
    ctaLabel: 'weiterlesen',
}

Tile.propTypes = {
    /** Titel der Kachel */
    title: propTypes.string.isRequired,
    /** Icon der Kachel */
    icon: propTypes.node.isRequired,
    /** Text unter der Kachel */
    text: propTypes.string.isRequired,
    /** Hintergrundfarbe der Kachel */
    bgColor: propTypes.string.isRequired,
    /** Farbe der Kachel */
    tileColor: propTypes.string.isRequired,
    /** Pfad für den Link (optional) */
    ctaPath: propTypes.string,
    /** Label für den Link */
    ctaLabel: propTypes.string,
}

export default Tile;